import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 266349FD-1B26-4BCD-A682-D25C4469B682
 * name crown
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crown.svg
 * tags
 */
export const CrownIcon = createSvgIcon(<><path d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z" /></>, 'CrownIcon');
export default CrownIcon